import {useLocation} from 'react-router-dom';

/**
 * `location.state` carried on links into a member detail page. The member list's
 * search, filters, sort, and page all live in its URL, so pointing Back at that
 * exact URL restores the view the user left.
 */
type MemberDetailLocationState = {from?: string};

/** State for a link into member detail whose Back returns to the current page. */
export function useMemberDetailLinkState(): MemberDetailLocationState {
  const {pathname, search} = useLocation();
  return {from: pathname + search};
}

/** The list URL the member detail page was opened from, if it was opened from one. */
export function useMemberDetailReturnTo(): string | undefined {
  const location = useLocation();
  return (location.state as MemberDetailLocationState | null)?.from;
}
